import axios from 'axios'
import { cleanBlankValue, openNewTabBlobFile } from 'utils/helper'

export const getFinanceOrders = (params, config = {}) => {
  return axios.get('/finance/orders', { params, ...config })
}

export const getTotalFinanceOrders = (params) => {
  return axios.get('/finance/orders/totals', { params })
}

export const addFinanceOrder = (data, config = {}) => {
  return axios.post('/finance/orders', data, config)
}

export const editFinanceOrder = (data, config = {}) => {
  return axios.put(`/finance/orders/${data.id}`, data, config)
}

export const deleteOnAddFinanceOrderAttachment = (url) => {
  return axios.delete('/finance/orders/attachments', { data: { url } })
}

export const deleteOnEditFinanceOrderAttachment = (id, url) => {
  return axios.delete(`/finance/orders/${id}/attachments`, { data: { url } })
}

export const getFinanceOrder = (id, params, config = {}) => {
  return axios.get(`/finance/orders/${id}`, { params, ...config })
}

export const getFinanceOrderLog = ({ id, params } = {}) => {
  return axios.get(`/finance/orders/${id}/logs`, { params })
}

export const changeFinanceOrderStatus = (id, data) => {
  return axios.patch(`/finance/orders/${id}/status`, data)
}

export const deleteFinanceOrder = (id) => {
  return axios.delete(`/finance/orders/${id}`)
}

export const getFinanceOrderOverview = () => {
  return axios.get(`/finance/orders/overview`)
}

export const uploadImportFinanceOrder = (data) => {
  return axios.postForm('/finance/orders/uploadImport', data)
}

export const executeImportFinanceOrder = (data) => {
  return axios.post('/finance/orders/executeImport', data)
}

export const createPdfFinanceOrder = (id) => {
  return axios
    .get(`/finance/orders/${id}/print`, { responseType: 'blob' })
    .then((response) => {
      openNewTabBlobFile(response)
      return Promise.resolve(true)
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

export const getFinanceOrderPublicUrl = (id) => {
  return axios.get(`/finance/orders/${id}/publicUrl`)
}

export const exportFinanceOrder = (params) => {
  const URL = params.status_id === 'recurring' ? 'orders/recurring/export' : 'orders/export'
  if (params.status_id === 'recurring') {
    delete params.status_id
  }
  const query = cleanBlankValue(params)
  return axios.get(`/finance/${URL}`, { responseType: 'arraybuffer', params: query })
}

export const getFinanceOrderWaTemplate = (id) => {
  return axios.get(`/finance/orders/${id}/whatsapp`)
}

export const getFinanceOrderInputWhatsappTemplate = (id) => {
  return axios.get(`/finance/orders/${id}/inputWhatsapp`)
}

export const sendFinanceOrderWhatsapp = (payload) => {
  const { id, ...body } = payload
  return axios.post(`/finance/orders/${id}/whatsapp`, body)
}

export const getFinanceOrderEmailTemplate = (id) => {
  return axios.get(`/finance/orders/${id}/email`)
}

export const sendFinanceOrderEmail = (id, data, config = {}) => {
  return axios.post(`/finance/orders/${id}/email`, data, config)
}

export const addRecurringOrder = (data) => {
  return axios.post('/finance/orders/recurring', data)
}

export const editRecurringOrder = (data) => {
  return axios.put(`/finance/orders/recurring/${data.id}`, data)
}

export const getRecurringOrder = (id) => {
  return axios.get(`/finance/orders/recurring/${id}`)
}

export const deleteRecurringOrder = (id) => {
  return axios.delete(`/finance/orders/recurring/${id}`)
}

export const getRecurringOrders = (params) => {
  return axios.get('/finance/orders/recurring', { params })
}

export const getFinanceOrderSmsTemplate = (id) => {
  return axios.get(`/finance/orders/${id}/sms`)
}

export const sendFinanceOrderSms = (id, data, config = {}) => {
  return axios.post(`/finance/orders/${id}/sms`, data, config)
}

export const inputMassDeleteFinanceOrder = (data) => {
  return axios.post('/finance/orders/inputMassDelete', data)
}

export const executeMassDeleteFinanceOrder = (data) => {
  return axios.delete('/finance/orders/executeMassDelete', { data })
}

export const inputMassSendEmailFinanceOrder = (data) => {
  return axios.post('/finance/orders/inputMassEmail', data)
}

export const executeMassSendEmailFinanceOrder = (data) => {
  return axios.post('/finance/orders/executeMassEmail', data)
}

export const inputMassSendWhatsappFinanceOrder = (data) => {
  return axios.post('/finance/orders/inputMassWhatsapp', data)
}

export const executeMassSendWhatsappFinanceOrder = (data) => {
  return axios.post('/finance/orders/executeMassWhatsapp', data)
}

export const getMassDownloadFinanceOrder = (params) => {
  return axios.get('/finance/orders/massDownload', { params })
}

export const getMinTransDateFinanceOrder = (data) => {
  return axios.post('/finance/orders/mass/minDate', data)
}

export const inputMassCreateFinanceOrder = (data) => {
  return axios.post('/finance/orders/inputMassOrder', data)
}

export const executeMassCreateFinanceOrder = (data) => {
  return axios.post('/finance/orders/executeMassOrder', data)
}

export const approveFinanceOrder = ({ id }) => {
  return axios.post(`/finance/orders/${id}/approve`)
}

export const rejectFinanceOrder = ({ id, body }) => {
  return axios.post(`/finance/orders/${id}/reject`, body)
}

export const revertApprovalFinanceOrder = ({ id }) => {
  return axios.post(`/finance/orders/${id}/revert`)
}

export const getTotalOrderPerOutlet = (params, config = {}) => {
  return axios.get(`/finance/orders/${params.outlet_id}/totals`, { params, ...config })
}

export const closeFinanceOrder = ({ id, body }, config = {}) => {
  return axios.post(`/finance/orders/${id}/close`, body, config)
}

export const uncloseFinanceOrder = ({ id }) => {
  return axios.post(`/finance/orders/${id}/unclose`)
}

export const editOnCompleteOrder = (data) => {
  return axios.patch(`/finance/orders/${data.id}`, data)
}
